import {Routes, Route} from 'react-router-dom'
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Math from './pages/Math';
import English from './pages/English';
import Misc from './pages/Misc';
import Request from './pages/Request';
import IconGeneration from './pages/IconGeneration';
const App = () => {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/math" element={<Math />}/>
        <Route path="/english" element={<English />}/>
        <Route path="/misc" element={<Misc />}/>
        <Route path="/request" element={<Request />}/>
        <Route path="/icongen" element={<IconGeneration />}/>
      </Routes>
    </div>
  );
}

export default App
